import { render, staticRenderFns } from "./record-list.vue?vue&type=template&id=05d67876&scoped=true"
import script from "./record-list.vue?vue&type=script&lang=ts"
export * from "./record-list.vue?vue&type=script&lang=ts"
import style0 from "./record-list.vue?vue&type=style&index=0&id=05d67876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d67876",
  null
  
)

export default component.exports